import { ExamAttempt, GradingMethod } from './exam-result-state'
import { scaleScore } from '@/app/shared/utils/scale-score'

// we do not allow negative score for questions
export function calculateExamResultWithoutNegative(
  questions: { raw: number, min: number, max: number }[])
{

  const score = questions.reduce((a,b) => a + b.raw, 0)
  const max = questions.reduce((a,b) => a + b.max, 0)

  return {
    raw: score,
    min: 0,
    max: max
  }
}

export function isExamPassed(score: { min: number, max: number, raw: number }, percentToPass: number) {
  const passingScore = calculatePassingScore(score.min, score.max, percentToPass)
  const isPassed = score.raw >= passingScore

  return {
    passingScore,
    isPassed
  }
}

function calculatePassingScore(min: number, max: number, passingPercent: number) {
  const passingScore = min + (max - min) * passingPercent / 100
  return passingScore
}

export function calculateEffectiveGrade(attempts: ExamAttempt[], method: GradingMethod) {
  if (attempts.length === 0) {
    return false
  }

  switch (method) {
    case 'highest-grade':
      const highest = calculateHighestGrade(attempts)
      if (highest === false) { throw new Error('Coding error') }

      return highest
    case 'last-attempt':
      return attempts[attempts.length - 1]
  }
}

function calculateHighestGrade(attempts: ExamAttempt[]) {

  const highest = attempts.reduce<ExamAttempt | null>((prev, next) => {
    if (prev === null) {
      return next
    }

    const range = { min: 0, max: 1 }
    const prevScaled = scaleScore(prev.score, range)
    const nextScaled = scaleScore(next.score, range)

    if (nextScaled > prevScaled) {
      return next
    } else {
      return prev
    }
  }, null)

  return highest || false
}

export function calculateExamPercent(score: { min: number, max: number, raw: number }) {
  return scaleScore(score, { min: 0, max: 100 })
}
